export default __webpack_public_path__ + "static/media/385.24aaa3a7.jpg";